import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { RegraConciliacaoAutomatica } from '../models/regra-conciliacao-automatica';
import { RegraConciliacaoAutomaticaSalvarResultado } from '../models/regra-conciliacao-automatica-salvar-resultado';

@Injectable({
  providedIn: 'root'
})
export class RegraConciliacaoAutomaticaApiService extends ApiService {

  private readonly baseRoute = '/regra-conciliacao-automatica';

  constructor(public override http: HttpClient) {
    super(http);
  }

  public listarPorContaCaixa(contaCaixaId: number): Observable<RegraConciliacaoAutomatica[]> {
    return this.get<RegraConciliacaoAutomatica[]>(`${this.baseRoute}/conta-caixa/${contaCaixaId}`);
  }

  public getById(id: number): Observable<RegraConciliacaoAutomatica> {
    return this.get<RegraConciliacaoAutomatica>(`${this.baseRoute}/${id}`);
  }

  public criar(input: RegraConciliacaoAutomatica): Observable<RegraConciliacaoAutomaticaSalvarResultado> {
    return this.post<RegraConciliacaoAutomaticaSalvarResultado>(this.baseRoute, undefined, this.mapParaRequest(input));
  }

  public editar(id: number, input: RegraConciliacaoAutomatica): Observable<RegraConciliacaoAutomaticaSalvarResultado> {
    return this.put<RegraConciliacaoAutomaticaSalvarResultado>(`${this.baseRoute}/${id}`, undefined, this.mapParaRequest(input));
  }

  public deletar(id: number): Observable<void> {
    return this.delete<void>(`${this.baseRoute}/${id}`);
  }

  private mapParaRequest(regra: RegraConciliacaoAutomatica) {
    return {
      contaCaixaId: regra.contaCaixaId,
      termoBusca: regra.termoBusca,
      tipoVerificacao: regra.tipoVerificacao,
      tipoLancamentoOrigemId: regra.tipoLancamentoOrigemId,
      observacaoOrigem: regra.observacaoOrigem,
      tipoLancamentoDestinoId: regra.tipoLancamentoDestinoId,
      observacaoDestino: regra.observacaoDestino,
      loteLancamento: regra.loteLancamento,
      observacao: regra.observacao,
    };
  }
}
